import {
  jb_checkmark_icon_css_default
} from "./chunk.CUF7SJXI.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.IIVCI7D3.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/icons/jb-checkmark-icon/jb-checkmark-icon.ts
var JbCheckmarkIcon = class extends Icon(r) {
  render() {
    return ke`
      <svg
        width="18"
        height="18"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.6012 12.4013C8.27526 12.7273 7.74686 12.7272 7.42095 12.4013L3.94464 8.92478C3.61873 8.59885 3.6187 8.07041 3.94464 7.74446C4.27057 7.4185 4.79897 7.41853 5.12488 7.74446L8.01107 10.6308L12.8971 5.74446C13.2231 5.4185 13.7515 5.41853 14.0774 5.74446C14.4033 6.07038 14.4033 6.59882 14.0774 6.92478L8.6012 12.4013Z"
          fill="var(--host-color, currentColor)"
        />
      </svg>
    `;
  }
};
JbCheckmarkIcon.styles = [reset_css_default, jb_checkmark_icon_css_default];
JbCheckmarkIcon = __decorateClass([
  customElement("jb-checkmark-icon")
], JbCheckmarkIcon);

export {
  JbCheckmarkIcon
};
